import { ReactComponent as DropdownIcon } from '@vkontakte/icons/src/svg/16/dropdown_outline_16.svg';
import { ReactComponent as UsersIcon } from '@vkontakte/icons/src/svg/16/users_2_outline_16.svg';
import classNames from 'clsx';
import React from 'react';

import stylesWeblink from '../Weblink/SharingNewWeblink.css';
import styles from './SharingNewSharing.css';

interface IProps {
    isCloudUsersOpened: boolean;
    setShowUsersScreen(value: boolean): void;
    isFolder: boolean;
}

const SharingNewSharingToggler: React.FC<IProps> = ({ setShowUsersScreen, isFolder }) => {
    return (
        <div className={classNames(stylesWeblink.rightsItem, { [stylesWeblink.rightsItemNoMargin]: true })}>
            <div className={stylesWeblink.titleWrapper}>
                <span className={stylesWeblink.icon}>
                    <UsersIcon />
                </span>
                <span className={stylesWeblink.rightsTitle}>{`Персональный доступ к ${isFolder ? 'папке' : 'файлу'}`}</span>
            </div>
            <div className={styles.toggler} onClick={() => setShowUsersScreen(true)}>
                Настроить <DropdownIcon />
            </div>
        </div>
    );
};

export default SharingNewSharingToggler;
